













import {Component, Prop, Vue} from 'vue-property-decorator'
import {Action} from 'vuex-class'


@Component({
  components: {
  },
})
export default class ErrorView extends Vue {
  @Action('closeDialog') public closeDialog: any

  @Prop({default: 'alert.png'}) private image?: string
  @Prop({default: '-CODE-'}) private code!: string
  @Prop({default: '-TITLE-'}) private title!: string
  @Prop({default: '-SUBTITLE-'}) private subtitle!: string
}
